import React from 'react'
import { spring } from 'react-motion'
import EasingMotion from './easing-motion'
import { SPRING, CHART_DEBUG } from '../constants'
import { guardProps } from './validate'

class EasingBar extends React.PureComponent {
  static defaultProps = {
    clipPadding: 10,
    maxWidth: 40,
    opacity: 1,
    padding: 0
  }

  centerWidth() {
    const { maxWidth, width, padding } = this.props

    return Math.min(maxWidth, width) - padding * 2
  }

  centerX() {
    const { width, x } = this.props

    // Limit the maximum width to prevent "fat" columns
    const barWidth = this.centerWidth()

    // If the bar width is limited, we need to offset the position by
    // the difference
    return x + Math.max(0, width - barWidth) * 0.5
  }

  renderLine({ x, y1, y2, width, height }) {
    const { opacity } = this.props

    const path = `M${x},${y1} L${x + width},${y1} L${x +
      width},${y2} L${x},${y2} Z`

    return <path d={path} opacity={opacity} />
  }

  renderClipping() {
    const { x, y1, y2, width, clipPadding } = this.props

    const y = Math.min(y1, y2)
    const height = Math.abs(y2 - y1)
    const stroke = CHART_DEBUG ? 'magenta' : 'transparent'

    return (
      <rect
        x={x}
        y={y - clipPadding}
        width={width}
        height={height + clipPadding * 2}
        fill="transparent"
        strokeDasharray="2 2"
        stroke={stroke}
      />
    )
  }

  render() {
    const { fill, stroke, label, y1, y2 } = this.props

    if (guardProps(this, 'x', 'y1', 'y2', 'width')) {
      return null
    }

    const style = {
      x: spring(this.centerX(), SPRING),
      y1: spring(y1, SPRING),
      y2: spring(y2, SPRING),
      width: spring(this.centerWidth(), SPRING)
    }

    const staticState = {
      ...this.props,
      x: this.centerX(),
      width: this.centerWidth()
    }

    return (
      <g className="easing-bar" fill={fill} stroke={stroke}>
        <title>{label}</title>

        <EasingMotion style={style} static={staticState}>
          {style => this.renderLine(style)}
        </EasingMotion>

        {this.renderClipping()}
      </g>
    )
  }
}

export default EasingBar



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-bar.js